import { motion } from 'framer-motion';

export function MidCTABanner() {
  const handleQuote = () => {
    const el = document.getElementById('get-quote') || document.getElementById('quote-form');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-6 bg-gradient-to-r from-orange-500 via-orange-500 to-orange-600">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col md:flex-row items-center justify-between gap-4"
        >
          <div className="flex items-center space-x-4">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-map-pin-2-fill text-white text-lg"></i>
            </div>
            <div>
              <p className="text-white font-bold text-base">
                Serving Arlington, Grand Prairie, Fort Worth &amp; all of DFW
              </p>
              <p className="text-orange-100 text-xs">
                Call <strong>817-860-9310</strong> · Mon–Fri 8 AM–6 PM · Same-week turnaround
                available
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3 flex-shrink-0">
            <a
              href="tel:817-860-9310"
              className="px-5 py-2.5 bg-white/20 backdrop-blur-sm text-white font-bold rounded-full hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer border border-white/30 text-sm"
            >
              <i className="ri-phone-fill mr-1"></i>
              Call Now
            </a>
            <button
              onClick={handleQuote}
              className="px-6 py-2.5 bg-white text-orange-600 font-bold rounded-full hover:bg-orange-50 transition-all whitespace-nowrap cursor-pointer text-sm hover:scale-105"
            >
              Get a Free Quote
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
